module.exports = __webpack_public_path__ + "img/20200325135902424.3942351b.png";